import { Card, Grid, useTheme } from "@mui/material";
import { getSensorTypeName } from "helpers/ExternalDeviceHelper";
import { ISensorDataExtended } from "models/ISensor";
import moment from "moment";
import { useGetSensorTypesQuery } from "features/api/apiSlice";
import { useTranslation } from "react-i18next";
import i18n from "app/i18n";

const SensorValueCard = ({ sensorDataExtended }: { sensorDataExtended: ISensorDataExtended }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { data: sensorTypes = [] } = useGetSensorTypesQuery();

    return(
        <>
            <Card
                sx={{
                    border: '1px solid',
                    borderRadius: 1,
                    borderColor: theme.palette.divider,
                    boxShadow: 'inherit',
                    padding: '5px'
                }}
              >
                <Grid container spacing={1} direction="column" alignItems="center">
                    <Grid item lineHeight="normal">{getSensorTypeName(sensorDataExtended.typeId, sensorTypes, t)}</Grid>
                    <Grid item lineHeight="normal" fontWeight="bold">
                    {sensorDataExtended.lastValue % 1 === 0 // Check if the number has decimals
                        ? sensorDataExtended.lastValue // If no decimals, display as is
                        : sensorDataExtended.lastValue.toFixed(2) // If decimals, truncate to two decimals
                    } {sensorDataExtended.unit}    
                    </Grid>
                    <Grid item lineHeight="normal" color="grey">{moment(sensorDataExtended.lastValueAt.toString()).locale(i18n.language).format('l LTS')}</Grid>
                </Grid>
            </Card>
        </>
    )
}

export default SensorValueCard;